import { number, z } from 'zod';

export type TConfiguration = z.infer<typeof configurationSchema>;

export const configurationSchema = z.object({
  id: number(),
  theme: z.enum([
    'Blue 900',
    'Gray 800',
    'Nature Cleaning Services',
    'Nature Solar Cells',
    'Nature Realtor',
    'Nature Moving Services',
    'Nature Lawyer',
    'Nature Plumber',
    'Nature Electrician',
    'Nature Auditor',
    'Nature Garage',
    'Nature Painter',
  ]),
  cardStyle: z.enum(['Fixed', 'Floating']),
  cardTextAlignment: z.enum(['Left', 'Right', 'Center']),
  cardVisibleRows: z.string(),
  showBasicProfileActionButtons: z.boolean(),
  includeOffices: z.boolean(),
  moreInfoButtonOnProductCards: z.boolean(),
});
